import { DataColumns } from '../DataColumns/DataColumns';
import GridFlag from '../../../../Core/Components/GridFlag/GridFlag';
import {
  BooleanValuesFilterCell,
  GridDateCell,
} from '../../../../Core/Components/Filter/FilterElements';
import { MultiViewCalenderFilterCell } from 'smart-react';

/**
 * Generates a list of columns for a grid.
 * @param {object} options - The options for the grid.
 * @returns {Array} - The list of grid columns.
 */
export const GridColumnsList = async ({
  editContentSlider,
  dateRangefilter,
  setDateRangeFilter,
}) => {
  return DataColumns({
    editContentSlider,
    GridFlag,
    BooleanValuesFilterCell,
    MultiViewCalenderFilterCell,
    dateRangeFilter: dateRangefilter,
    setDateRangeFilter,
    GridDateCell,
  });
};

export default GridColumnsList;
